module.exports = __webpack_public_path__ + "static/media/alienCallig1.9100d1e0.jpeg";